export default "__VITE_ASSET__0be653c0__"